/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jolly_Yummy_Anteater_AskInputs */

const fr_jolly_yummy_anteater_ask = /** @type {(inputs: Jolly_Yummy_Anteater_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrouvez toutes les informations liées à votre abonnement`)
};

/**

* @param {Jolly_Yummy_Anteater_AskInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const jolly_yummy_anteater_ask = /** @type {((inputs?: Jolly_Yummy_Anteater_AskInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jolly_Yummy_Anteater_AskInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_jolly_yummy_anteater_ask(inputs)
});